module.exports = __webpack_public_path__ + "img/activate_guide_3.45a14aef.jpg";